/**
 * This file was auto-generated by Fern from our API Definition.
 */
import { Accounts } from "./api/resources/accounts/client/Client";
import { Actions } from "./api/resources/actions/client/Client";
import { AgentExports } from "./api/resources/agentExports/client/Client";
import { Agents } from "./api/resources/agents/client/Client";
import { Analysis } from "./api/resources/analysis/client/Client";
import { Apps } from "./api/resources/apps/client/Client";
import { Assistant } from "./api/resources/assistant/client/Client";
import { Auth } from "./api/resources/auth/client/Client";
import { Billing } from "./api/resources/billing/client/Client";
import { CanvasAreas } from "./api/resources/canvasAreas/client/Client";
import { Canvas } from "./api/resources/canvas/client/Client";
import { Cells } from "./api/resources/cells/client/Client";
import { Commits } from "./api/resources/commits/client/Client";
import { DataClips } from "./api/resources/dataClips/client/Client";
import { DataRetentionPolicies } from "./api/resources/dataRetentionPolicies/client/Client";
import { Deprecated } from "./api/resources/deprecated/client/Client";
import { Documents } from "./api/resources/documents/client/Client";
import { Entitlements } from "./api/resources/entitlements/client/Client";
import { Environments } from "./api/resources/environments/client/Client";
import { Events } from "./api/resources/events/client/Client";
import { Files } from "./api/resources/files/client/Client";
import { Flags } from "./api/resources/flags/client/Client";
import { Foreigndb } from "./api/resources/foreigndb/client/Client";
import { Frontegg } from "./api/resources/frontegg/client/Client";
import { Guests } from "./api/resources/guests/client/Client";
import { Health } from "./api/resources/health/client/Client";
import { Jobs } from "./api/resources/jobs/client/Client";
import { Mapping } from "./api/resources/mapping/client/Client";
import { Messages } from "./api/resources/messages/client/Client";
import { OnboardingDatapoints } from "./api/resources/onboardingDatapoints/client/Client";
import { Onboardings } from "./api/resources/onboardings/client/Client";
import { Records } from "./api/resources/records/client/Client";
import { Roles } from "./api/resources/roles/client/Client";
import { Routines } from "./api/resources/routines/client/Client";
import { Runbooks } from "./api/resources/runbooks/client/Client";
import { Secrets } from "./api/resources/secrets/client/Client";
import { Sheets } from "./api/resources/sheets/client/Client";
import { Snapshots } from "./api/resources/snapshots/client/Client";
import { Spaces } from "./api/resources/spaces/client/Client";
import { Threads } from "./api/resources/threads/client/Client";
import { Transformations } from "./api/resources/transformations/client/Client";
import { Users } from "./api/resources/users/client/Client";
import { Versions } from "./api/resources/versions/client/Client";
import { Views } from "./api/resources/views/client/Client";
import { Webhook } from "./api/resources/webhook/client/Client";
import { Workbooks } from "./api/resources/workbooks/client/Client";
export class FlatfileClient {
    constructor(_options = {}) {
        this._options = _options;
    }
    get accounts() {
        return (this._accounts ?? (this._accounts = new Accounts(this._options)));
    }
    get actions() {
        return (this._actions ?? (this._actions = new Actions(this._options)));
    }
    get agentExports() {
        return (this._agentExports ?? (this._agentExports = new AgentExports(this._options)));
    }
    get agents() {
        return (this._agents ?? (this._agents = new Agents(this._options)));
    }
    get analysis() {
        return (this._analysis ?? (this._analysis = new Analysis(this._options)));
    }
    get apps() {
        return (this._apps ?? (this._apps = new Apps(this._options)));
    }
    get assistant() {
        return (this._assistant ?? (this._assistant = new Assistant(this._options)));
    }
    get auth() {
        return (this._auth ?? (this._auth = new Auth(this._options)));
    }
    get billing() {
        return (this._billing ?? (this._billing = new Billing(this._options)));
    }
    get canvasAreas() {
        return (this._canvasAreas ?? (this._canvasAreas = new CanvasAreas(this._options)));
    }
    get canvas() {
        return (this._canvas ?? (this._canvas = new Canvas(this._options)));
    }
    get cells() {
        return (this._cells ?? (this._cells = new Cells(this._options)));
    }
    get commits() {
        return (this._commits ?? (this._commits = new Commits(this._options)));
    }
    get dataClips() {
        return (this._dataClips ?? (this._dataClips = new DataClips(this._options)));
    }
    get dataRetentionPolicies() {
        return (this._dataRetentionPolicies ?? (this._dataRetentionPolicies = new DataRetentionPolicies(this._options)));
    }
    get deprecated() {
        return (this._deprecated ?? (this._deprecated = new Deprecated(this._options)));
    }
    get documents() {
        return (this._documents ?? (this._documents = new Documents(this._options)));
    }
    get entitlements() {
        return (this._entitlements ?? (this._entitlements = new Entitlements(this._options)));
    }
    get environments() {
        return (this._environments ?? (this._environments = new Environments(this._options)));
    }
    get events() {
        return (this._events ?? (this._events = new Events(this._options)));
    }
    get files() {
        return (this._files ?? (this._files = new Files(this._options)));
    }
    get flags() {
        return (this._flags ?? (this._flags = new Flags(this._options)));
    }
    get foreigndb() {
        return (this._foreigndb ?? (this._foreigndb = new Foreigndb(this._options)));
    }
    get frontegg() {
        return (this._frontegg ?? (this._frontegg = new Frontegg(this._options)));
    }
    get guests() {
        return (this._guests ?? (this._guests = new Guests(this._options)));
    }
    get health() {
        return (this._health ?? (this._health = new Health(this._options)));
    }
    get jobs() {
        return (this._jobs ?? (this._jobs = new Jobs(this._options)));
    }
    get mapping() {
        return (this._mapping ?? (this._mapping = new Mapping(this._options)));
    }
    get messages() {
        return (this._messages ?? (this._messages = new Messages(this._options)));
    }
    get onboardingDatapoints() {
        return (this._onboardingDatapoints ?? (this._onboardingDatapoints = new OnboardingDatapoints(this._options)));
    }
    get onboardings() {
        return (this._onboardings ?? (this._onboardings = new Onboardings(this._options)));
    }
    get records() {
        return (this._records ?? (this._records = new Records(this._options)));
    }
    get roles() {
        return (this._roles ?? (this._roles = new Roles(this._options)));
    }
    get routines() {
        return (this._routines ?? (this._routines = new Routines(this._options)));
    }
    get runbooks() {
        return (this._runbooks ?? (this._runbooks = new Runbooks(this._options)));
    }
    get secrets() {
        return (this._secrets ?? (this._secrets = new Secrets(this._options)));
    }
    get sheets() {
        return (this._sheets ?? (this._sheets = new Sheets(this._options)));
    }
    get snapshots() {
        return (this._snapshots ?? (this._snapshots = new Snapshots(this._options)));
    }
    get spaces() {
        return (this._spaces ?? (this._spaces = new Spaces(this._options)));
    }
    get threads() {
        return (this._threads ?? (this._threads = new Threads(this._options)));
    }
    get transformations() {
        return (this._transformations ?? (this._transformations = new Transformations(this._options)));
    }
    get users() {
        return (this._users ?? (this._users = new Users(this._options)));
    }
    get versions() {
        return (this._versions ?? (this._versions = new Versions(this._options)));
    }
    get views() {
        return (this._views ?? (this._views = new Views(this._options)));
    }
    get webhook() {
        return (this._webhook ?? (this._webhook = new Webhook(this._options)));
    }
    get workbooks() {
        return (this._workbooks ?? (this._workbooks = new Workbooks(this._options)));
    }
}
